import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import DOMPurify from 'dompurify';
import { buildFormulaImageUrl } from '../../utils/buildFormulaImageUrl';

interface FormulaModalProps {
  visible: boolean;
  onClose: () => void;
  formula?: string | null;
  formulaImagem?: string | null;
}

export const FormulaModal: React.FC<FormulaModalProps> = ({
  visible,
  onClose,
  formula,
  formulaImagem,
}) => {
  if (!formula && !formulaImagem) return null;

  const isTextFormula = !!formula;

  return (
    <Modal
      title={isTextFormula ? 'Fórmula' : undefined}
      width={800}
      zIndex={10001}
      footer={null}
      closable
      maskClosable={false}
      destroyOnClose
      visible={visible}
      onCancel={onClose}
      wrapClassName="lectureContainerVideo"
      className="modal-lecture-video"
      closeIcon={<button className="button-close"><CloseOutlined /></button>}
    >
      {isTextFormula ? (
        <div className="text-area" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formula) }} />
      ) : (
        <img
          src={buildFormulaImageUrl(formulaImagem!)}
          alt="Fórmula"
          style={{ width: '100%', height: 'auto' }}
        />
      )}
    </Modal>
  );
};
